// extracted by mini-css-extract-plugin
export var children = "Modal-module--children--e6fe7";
export var closeContainer = "Modal-module--closeContainer--78955";
export var container = "Modal-module--container--cd0bb";
export var icon = "Modal-module--icon--9ef77";